import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Bigscreen from "./Bigscreen";
import Description from "./Description";
import Gallery from "../Gallery";
import Hero from "../Hero";
import Intro from "./Intro";
import Metrics from "./Metrics";
import UnderConstruction from "../UnderConstruction"; // Import the UnderConstruction component

export default function StudyTemplate() {
  const { slug } = useParams();
  const [dynamicContent, setDynamicContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(
          `/assets/portfoliopages/study/${slug}.json`
        );
        if (response.ok) {
          const json = await response.json();
          setDynamicContent(json);
        } else {
          setDynamicContent({});
        }
      } catch (error) {
        console.error(`An error occurred: ${error}`);
        setDynamicContent({});
      }
    };
    fetchContent();
  }, [slug]);

  if (dynamicContent === null) {
    return null; // Display nothing or a loader until the content is fetched
  }

  const isUnderConstruction = dynamicContent.State === "UnderConstruction";

  return (
    <div>
      <Hero />
      {isUnderConstruction ? (
        <UnderConstruction />
      ) : (
        <>
          <Intro dynamicContent={dynamicContent} />
          <Bigscreen slug={slug} />
          <Description slug={slug} dynamicContent={dynamicContent} />
          <Gallery slug={slug} />
          <Metrics slug={slug} dynamicContent={dynamicContent} />
        </>
      )}
    </div>
  );
}
